import { render } from "./formal_document_template_preview_view.html?vue&type=template&id=18eb7698&scoped=true&external"
import script from "./formal_document_template_preview.js?vue&type=script&lang=js&external"
export * from "./formal_document_template_preview.js?vue&type=script&lang=js&external"

import "./FormalDocumentTemplatePreview.vue?vue&type=style&index=0&id=18eb7698&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18eb7698"]])

export default __exports__